import {Info} from '../../../services/info/types/info';

export const initialInfoState: Info = {
  build: {
    version: undefined
  },
  application: {
    name: undefined,
    version: undefined
  }
}
